import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const navigationSelf = handleActions(
  {
    [actionTypes.NAVIGATION_DETAILS_REQUEST]: (state, { payload }) => ({
      type: payload.type,
      title: 'loading..',
    }),
    [actionTypes.NAVIGATION_DETAILS_SUCCESS]: (state, { payload }) => payload.self || {},
    [actionTypes.CLEAR_NAVIGATION_DETAILS]: () => ({}),
  },
  {},
);

const mapNavigationLinks = links =>
  links ? links?.map(link => ({ ...link, uri: `/${link.uri}` })).reverse() : [];

export const navigationParents = handleActions(
  {
    [combineActions(
      actionTypes.NAVIGATION_DETAILS_REQUEST,
      actionTypes.CLEAR_NAVIGATION_DETAILS,
    )]: () => [],
    [actionTypes.NAVIGATION_DETAILS_SUCCESS]: (state, { payload }) =>
      mapNavigationLinks(payload.parents),
  },
  [],
);

export const navigationChilds = handleActions(
  {
    [combineActions(
      actionTypes.NAVIGATION_DETAILS_REQUEST,
      actionTypes.CLEAR_NAVIGATION_DETAILS,
    )]: () => [],
    [actionTypes.NAVIGATION_DETAILS_SUCCESS]: (state, { payload }) =>
      mapNavigationLinks(payload.childs),
  },
  [],
);

export const loading = handleActions(
  {
    [actionTypes.NAVIGATION_DETAILS_REQUEST]: () => true,
    [combineActions(
      actionTypes.NAVIGATION_DETAILS_SUCCESS,
      actionTypes.NAVIGATION_DETAILS_FAILURE,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.NAVIGATION_DETAILS_REQUEST,
      actionTypes.NAVIGATION_DETAILS_SUCCESS,
    )]: () => ({}),
    [actionTypes.NAVIGATION_DETAILS_FAILURE]: (state, { payload }) => payload.error,
  },
  {},
);

export const shouldNavigationUpdate = handleActions(
  {
    [actionTypes.CHANGE_NAVIGATION_CONTEXT]: (state, { payload }) => payload.shouldUpdate,
  },
  false,
);

export const activeContext = handleActions(
  {
    [actionTypes.NAVIGATION_DETAILS_SUCCESS]: (state, { payload }) => state ||
      payload.self?.id,
    [actionTypes.CHANGE_NAVIGATION_CONTEXT]: (state, { payload }) => payload.context,
    [actionTypes.CLEAR_NAVIGATION_DETAILS]: () => '',
  },
  '',
);

export const activeTechnician = handleActions(
  {
    [actionTypes.CHANGE_NAVIGATION_CONTEXT]: (state, { payload }) =>
      typeof payload.technician === 'undefined' ? state : payload.technician || '',
  },
  '',
);

export const expand = handleActions(
  {
    [actionTypes.TOGGLE_NAVIGATION_MENU]: state => !state,
  },
  false,
);

export const isNavigationBlocked = handleActions(
  {
    [actionTypes.BLOCK_NAVIGATION]: (state, { payload }) => payload,
  },
  false,
);

export const promptInfo = handleActions(
  {
    LOCATION_CHANGE: () => null,
    [actionTypes.SET_PROMPT_INFO]: (state, { payload }) => payload,
  },
  null,
);

export default combineReducers({
  navigationSelf,
  navigationParents,
  navigationChilds,
  activeContext,
  activeTechnician,
  shouldNavigationUpdate,
  expand,
  error,
  loading,
  isNavigationBlocked,
  promptInfo,
});
